import * as type from "../../types/API/documentApprovaltype";
import { IAction } from "../userMetadataReducer";

const initialState = {
    data: null,
    loading: false,
    error: null,
}

export const setApprovalPermissionReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.SET_APPROVAL_PERMISSION:
            return {
                ...state,
                loading: true,
            };
        case type.SET_APPROVAL_PERMISSION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.responseData?.message || ''
            };
        case type.SET_APPROVAL_PERMISSION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const getApprovalPermissionReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_APPROVAL_PERMISSION:
            return {
                ...state,
                loading: true,
            };
        case type.GET_APPROVAL_PERMISSION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.responseData?.data || ''
            };
        case type.GET_APPROVAL_PERMISSION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const approveDocumentReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.APPROVED_DOCUMENT:
            return {
                ...state,
                loading: true,
            };
        case type.APPROVED_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.responseData?.message || ''
            };
        case type.APPROVED_DOCUMENT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};

export const deleteApprovalPermissionReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.DELETE_APPROVAL_PERMISSION:
            return {
                ...state,
                loading: true,
            };
        case type.DELETE_APPROVAL_PERMISSION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload?.responseData?.message || ''
            };
        case type.DELETE_APPROVAL_PERMISSION_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};